import React, { useCallback, useRef, useEffect } from 'react';

const ResizeHandle = ({ onResize, onResizeEnd }) => {
  const isDragging = useRef(false);
  const startX = useRef(0);
  const overlayRef = useRef(null);

  const handleMouseDown = useCallback((e) => {
    e.preventDefault();
    isDragging.current = true;
    startX.current = e.clientX;

    // Create full-screen overlay to prevent iframe/selection issues
    const overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;z-index:99999;cursor:col-resize;';
    document.body.appendChild(overlay);
    overlayRef.current = overlay;

    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
  }, []);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isDragging.current) return;
      const deltaX = e.clientX - startX.current;
      startX.current = e.clientX;
      onResize?.(deltaX);
    };

    const handleMouseUp = () => {
      if (!isDragging.current) return;
      isDragging.current = false;

      // Remove overlay
      if (overlayRef.current) {
        overlayRef.current.remove();
        overlayRef.current = null;
      }

      document.body.style.cursor = '';
      document.body.style.userSelect = '';
      onResizeEnd?.();
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      // Cleanup overlay on unmount
      if (overlayRef.current) {
        overlayRef.current.remove();
        overlayRef.current = null;
      }
    };
  }, [onResize, onResizeEnd]);

  return (
    <div
      className="bear-resize-handle"
      onMouseDown={handleMouseDown}
    />
  );
};

export default ResizeHandle;
